import { useState, useEffect, useContext } from 'react';
import { Box, Card, Divider, Grid, IconButton, Tooltip, tooltipClasses, Typography, Skeleton, useTheme } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { showModal } from "react-redux-modal-provider";
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import EditIcon from '@mui/icons-material/Edit';
import BadgeIcon from '@mui/icons-material/Badge';
import { ButtonBasic, CardOTZTask, SelectNivelVIP, TextInfoTicket } from '../../components';
import TratoService from '../../services/tratos.service';
import TabCuentaTicket from '../contacto/tabs/TabCuentaTicket';
import AuxiliarFunction from '../../function/AuxiliarFunction';
import DownloadFile from '../../services/downloadFile.service';
import FechaFunction from '../../function/FechaFunction';
import TabContactoPreServicio from '../contacto/tabs/TabContactoPreServicio';
import ConfirmationDialog from '../../modals/default/ConfirmationDialog';
import TabCuentaTareas from '../contacto/tabs/TabCuentaTareas';
import CalendarioV2Service from '../../services/calendarioV2.service';
import ApiSoftland from '../../services/apis.softland.service';
import TabCuentaHistorico from '../contacto/tabs/TabCuentaHistorico';
import LogService from '../../services/log.service';
import ModalEstadoPreServicio from '../../modals/servicio/ModalEstadoPreServicio';
import ReportesService from '../../services/reportes.service';
import TabCuentaRecodatorios from '../contacto/tabs/TabCuentaRecodatorios';
import RecordatorioService from '../../services/recordatorio.service';
import usePermisos from '../../hooks/usePermisos';
import ModalEditarPreServicio from '../../modals/tratos/ModalEditarPreServicio';
import { SocketContext } from '../../context/SocketContext';
import ZTaskService from '../../services/ztask.service';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
        {value === index && (
            <Box sx={{ p: 3 }}>{children}</Box>
        )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const DynamicTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.mode === 'dark' ? '#2d3a52' : theme.palette.common.white,
        color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'rgba(0, 0, 0, 0.87)',
        border: theme.palette.mode === 'dark' ? '1px solid #3d4a62' : 'none',
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}));

const PreServicioVerScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const {id,type} = useParams();
    const { sockets } = useContext(SocketContext);
    const permisos = usePermisos();
    const [isLoading, setIsLoading] = useState(true);
    const [trato, setTrato] = useState();
    const [tareas, setTareas] = useState([]);
    const [logs, setLogs] = useState([]);
    const [recordatorios, setRecordatorios] = useState([]);
    const [otsServicio, setOtsServicio] = useState([]);
    const excluirEstados = [
        'PENDIENTE DE ALTA EN SOFTLAND POR VALIDACION DE DOCUMENTACION',
        'INSTALADO',
        'NUEVO PRE-SERVICIO CORPORATIVO',
        'NUEVO PRE-SERVICIO GOBIERNO',
        'INSTALACION CANCELADA',
        'CANCELADO POR FALTA DE DOCUMENTACIÓN',
        'NO AUTORIZADO - VIP'
    ];
    const navigate = useNavigate();
    const actualizar = async() =>{
        await TratoService.getById(id,{type}).then((r)=>{
            if(r?.cuentaContratoId_t){
                navigate(`/servicio/${r.cuentaContratoId_t}/cuenta`)
            }
            setTrato(r)
        })
        .catch(()=>{
            navigate(`/servicio/${id}/cuenta`);
        })
        .finally(()=>{
            setIsLoading(false)
        })
    }
    const actualizarTareas = async() =>{
        await CalendarioV2Service.tareasCalendar({contratoId: id}).then((resp)=>{
            setTareas(resp)
        })
    }
    const actualizarHistorico = async() =>{
        await LogService.getAllContacto({preServicio: id}).then((resp)=>{
            setLogs(resp)
        })
    }
    const actualizarOTs = async() =>{
      if(permisos["permiso.enlaces.web"]) return;
      await ZTaskService.getOTServicio({ servicioId: id, all: true }).then((resp)=>{
        setOtsServicio(resp?.ots || resp?.data?.ots || []);
      }).catch(() => {
        setOtsServicio([]);
      })
    }
    useEffect(() => {
        const room = `pre-servicio-${id}`;
        sockets?.emit('joinTicketRoom', room);
        actualizar();
        actualizarTareas();
        actualizarHistorico();
        actualizarRecordatorios();
        actualizarOTs();
        document.title = `Pre-Servicio #${id}`;

        const onPreServicioRefresh = () => {
            actualizar();
            actualizarTareas();
            actualizarHistorico();
            actualizarRecordatorios();
            actualizarOTs();
        };
        sockets?.on('preServicioRefresh', onPreServicioRefresh);

        return () => {
            sockets?.off('preServicioRefresh', onPreServicioRefresh);
            sockets?.emit('leaveTicketRoom', room);
        };
    }, [id])
    const onGuardar = () => {
        actualizar();
        actualizarTareas();
        actualizarHistorico();
        actualizarRecordatorios();
    }
    /* const onOpenConfirmarInstalacion = async() =>{
        showModal(ModalConfirmInstalacion, {tratoId: id, onGuardar: actualizar});
    } */
    const downloadPdfContrato = async() =>{
        AuxiliarFunction.downloadFile(DownloadFile.contratoNubiPdf({id:id}),'contrato')
    }
    const checkVinculacion = async() => {
        await ApiSoftland.checkServicioSoftland(id);
    }
    const onClickNameCliente = () =>{
        if(trato?.cuentaId_t){
            navigate(`/contactos/${trato?.cuentaId_t}/cuenta`)
        }else{
            navigate(`/contactos/${trato?.contactoId_t}/nubicom`)
        }
    }
    const autorizarPreServicio = async() => {
        setIsLoading(true)
        await TratoService.autorizarBonificacion(id).then(()=>{
            actualizar();
            setTimeout(() => {
                actualizarTareas();
                actualizarHistorico();
            }, 800);
        }).finally(()=>{
            setIsLoading(false)
        })
    }

    const noAutorizarPreServicio = async() => {
        setIsLoading(true)
        await TratoService.noAutorizarBonificacion({idTrato:id}).then(()=>{
            actualizar();
            setTimeout(() => {
                actualizarTareas();
                actualizarHistorico();
            }, 800);
        }).finally(()=>{
            setIsLoading(false)
        })
    }

    const onOpenModalAutorizar = () =>{
        showModal(ConfirmationDialog, {
            title: 'Autorizar Pre-Servicio',
            message: `¿Esta seguro que desea autorizar el pre-servicio #${id} ?`,
            onConfirm: () => autorizarPreServicio()
        });
    }

    const onOpenModalNoAutorizar = () =>{
        showModal(ConfirmationDialog, {
            title: 'Rechazar Pre-Servicio',
            message: `¿Esta seguro que desea no autorizar el pre-servicio #${id} ?`,
            onConfirm: () => noAutorizarPreServicio()
        });
    }

    const changeEstadoPreServicio = () =>{
        showModal(ModalEstadoPreServicio, { item: trato, onGuardar: onGuardar });
    }
    const editPreServicioModal = () =>{
        showModal(ModalEditarPreServicio, { item: trato, onGuardar: onGuardar });
    }
    const onReporteServicioId = async() => {
        await AuxiliarFunction.downloadFile(
            ReportesService.reporteServicioId(id),
            id
        )
    }
    const actualizarRecordatorios = async() =>{
        if(permisos["permiso.enlaces.web"]) return;
        await RecordatorioService.getAll({preServicioId: id}).then((resp)=>{
            setRecordatorios(resp)
        })
    }

    const onSelectVip = async(itemValue) => {
        await TratoService.changeNivelVip({tratoId: id, nivelVip_t: itemValue}).then(()=>{
            actualizar();
            actualizarHistorico();
        })
    }
    const actualizarDataLogs = () => {
        actualizar();
        actualizarHistorico();
    }

    if (isLoading) {
        return (
            <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
                <Grid container p={3} mb={5} spacing={1}>
                    <Grid item xs={12} md={3}>
                        <Card sx={{background: isDarkMode ? '#2d3a52' : '#fff', border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`, p:2,borderRadius:4,boxShadow: isDarkMode ? '0px -3px 0px 0px #90caf9' : '0px -3px 0px 0px #15294b'}}>
                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
                                <Skeleton variant="circular" width={40} height={40} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                                <Skeleton variant="circular" width={40} height={40} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            </Box>
                            <Box sx={{ display:'flex', justifyContent: 'center', alignItems: 'center',mb: 2, flexDirection: 'column'}}>
                                <Skeleton variant="circular" width={80} height={80} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                                <Skeleton variant="text" width="80%" height={40} sx={{mt: 1, bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            </Box>
                            <Divider sx={{mb: 2, background: isDarkMode ? '#3d4a62' : '#e0e0e0'}} />
                            <Skeleton variant="text" width="60%" height={30} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0', mb: 1}} />
                            <Skeleton variant="rectangular" width="100%" height={45} sx={{borderRadius: 2, mb: 1, bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            <Skeleton variant="rectangular" width="100%" height={45} sx={{borderRadius: 2, mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            <Divider sx={{mb: 2, background: isDarkMode ? '#3d4a62' : '#e0e0e0'}} />
                            <Skeleton variant="text" width="100%" height={30} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            <Skeleton variant="text" width="100%" height={30} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            <Skeleton variant="text" width="100%" height={30} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            <Skeleton variant="text" width="100%" height={30} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            <Skeleton variant="text" width="100%" height={30} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <Card sx={{background: isDarkMode ? '#2d3a52' : '#fff', border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`, p:2,borderRadius:4}}>
                            <Box sx={{ borderBottom: 1, borderColor: isDarkMode ? '#3d4a62' : '#e0e0e0', mb: 2 }}>
                                <Skeleton variant="rectangular" width="100%" height={48} sx={{bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            </Box>
                            <Box sx={{p: 3}}>
                                <Skeleton variant="text" width="60%" height={40} sx={{mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                                <Skeleton variant="rectangular" width="100%" height={200} sx={{borderRadius: 2, mb: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                                <Skeleton variant="rectangular" width="100%" height={200} sx={{borderRadius: 2, bgcolor: isDarkMode ? '#1F2A40' : '#e0e0e0'}} />
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    }

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
        <Grid container p={3} mb={5} spacing={1}>
            <Grid item xs={12} md={3}>
            <Card sx={{background: isDarkMode ? '#2d3a52' : '#fff', border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`, p:2,borderRadius:4,boxShadow: isDarkMode ? '0px -3px 0px 0px #90caf9' : '0px -3px 0px 0px #15294b'}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <DynamicTooltip  title="Atrás" placement="top">
                        <IconButton sx={{background: isDarkMode ? '#1F2A40' : 'transparent', boxShadow: 3}} onClick={()=>navigate(-1)}>
                            <ArrowBackIcon sx={{color: isDarkMode ? '#90caf9' : '#15294b'}} />
                        </IconButton>
                    </DynamicTooltip>
                    <DynamicTooltip  title="Editar" placement="top">
                        <IconButton
                            sx={{
                                boxShadow: 3,
                                background: isDarkMode ? '#1F2A40' : '#fff',
                                backgroundColor: (permisos['editar.pre_servicio.Nubi'] || permisos["permiso.enlaces.web"]) ? (isDarkMode ? '#1F2A40' : '#fff') : '#9d9ea4 !important'
                            }}
                            onClick={()=>editPreServicioModal()}
                            disabled={!permisos['editar.pre_servicio.Nubi'] && !permisos["permiso.enlaces.web"]}
                        >
                            <EditIcon sx={{color: isDarkMode ? '#90caf9' : '#15294b', fontSize: 16}} />
                        </IconButton>
                    </DynamicTooltip>
                </Box>
                <Box sx={{ display:'flex', justifyContent: 'center', alignItems: 'center',mb: 1, flexDirection: 'column'}}>
                    <Box sx={{background: isDarkMode ? '#1F2A40' : '#f5f6f7', borderRadius:80, width:80, height: 80, display:'flex', justifyContent: 'center', alignItems: 'center',border:1 , borderColor: isDarkMode ? '#90caf9' : '#15294b'}}>
                        <ShoppingCartOutlinedIcon sx={{color: isDarkMode ? '#90caf9' : '#15294b',fontSize: 55}} />
                    </Box>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',textAlign: 'center',mt: 1}} variant='h4'>{`Pre-Servicio #${trato?.id_t}`}</Typography>
                </Box>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#8993a4',marginBottom:1,width: '100%'}} />
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',mb:2}}>
                    <Box sx={{background: isDarkMode ? '#1a3a5c' : '#e6f0ff', borderRadius:50, width:35, height: 35, display:'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <AccountCircleIcon sx={{color: isDarkMode ? '#90caf9' : '#15294b',fontSize: 25}} />
                    </Box>
                    <Typography
                        sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',textAlign: 'center',pl:0.5,cursor: 'pointer', '&:hover':{color: isDarkMode ? '#90caf9' : '#0364ff'}}}
                        variant='h6'
                        onClick={()=>onClickNameCliente()}
                    >
                        {trato?.nombre_t}
                    </Typography>
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column',mb: 2}}>
                    {trato?.listaPrecioSoft_t && trato?.listaPrecioSoft_t !== 'COR1      ' && (
                        <ButtonBasic
                            textButton='Descargar Contrato'
                            iconStart={<SaveAltOutlinedIcon />}
                            onClick={()=>downloadPdfContrato()}
                            variant='wk'
                            color='nextWhite'
                            sx={{border: 1}}
                        />
                    )}
                    <ButtonBasic
                        textButton='Revisar Vinculacion'
                        iconStart={<HowToRegIcon />}
                        onClick={()=>checkVinculacion()}
                        variant='wk'
                        color='nextWhite'
                        sx={{border: 1,mt:1}}
                    />
                </Box>
                {(trato?.nivelAutorizacion_t === 'bonificacion_nivel2' || trato?.nivelAutorizacion_t === 'bonificacion_nivel3') && !trato?.autorizadoxPersonalId_t &&(
                    <Box sx={{display: 'flex', justifyContent: 'center',mb: 2,flexDirection: 'column'}}>
                        <ButtonBasic
                            textButton='Autorizar Pre-Servicio'
                            iconStart={<AssignmentTurnedInOutlinedIcon />}
                            onClick={()=>onOpenModalAutorizar()}
                            variant='wk'
                            color='nextWhite'
                            sx={{border: 1}}
                        />
                        <ButtonBasic
                            textButton='No Autorizar Pre-Servicio'
                            iconStart={<AssignmentTurnedInOutlinedIcon />}
                            onClick={()=>onOpenModalNoAutorizar()}
                            variant='wk'
                            color='nextWhite'
                            sx={{border: 1,color: 'red', mt: 1}}
                        />
                    </Box>
                )}
                { !excluirEstados?.includes(trato?.estadoServicio_t) && !permisos["permiso.enlaces.web"] && (
                    <Box sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column',mb: 1}}>
                        <ButtonBasic
                            textButton='Cambiar Estado'
                            iconStart={<ChangeCircleOutlinedIcon />}
                            onClick={()=>changeEstadoPreServicio()}
                            variant='wk'
                            color='nextWhite'
                            sx={{border: 1}}
                        />
                    </Box>
                )}
                {!permisos["permiso.enlaces.web"] && (
                    <Box sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column',mb: 2}}>
                        <ButtonBasic
                            textButton='Descargar Reporte'
                            iconStart={<BackupTableIcon />}
                            onClick={()=>onReporteServicioId()}
                            variant='wk'
                            color='nextWhite'
                            sx={{border: 1}}
                        />
                    </Box>
                )}
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#8993a4',marginBottom:2,width: '100%'}} />
                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',textAlign: 'left',mb: 2}} variant='h6'>Datos del Pre-Servicio</Typography>
                <TextInfoTicket titulo='Estado' descripcion={trato?.estadoServicio_t} />
                {trato?.nivelVip_t && !permisos['bonificacion_nivel3'] && !permisos['bonificacion_nivel2'] && (
                    <TextInfoTicket titulo='Nivel VIP' descripcion={trato?.nivelVip_t} />
                )}
                {(permisos['bonificacion_nivel3'] || permisos['bonificacion_nivel2']) && (
                    <Box sx={{width: '90%',ml: 1, mb: 1,mt: 1}}>
                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold', fontSize: 13, ml: 1}}>
                            Nivel VIP
                        </Typography>
                        <SelectNivelVIP
                            isClearable
                            value={trato?.nivelVip_t}
                            onChange={(e)=>onSelectVip(e?.value)}
                        />
                    </Box>
                )}
                {trato?.subEstadoServicio_t && (
                    <TextInfoTicket titulo='Sub-Estado' descripcion={trato?.subEstadoServicio_t} />
                )}
                <TextInfoTicket titulo='Total Ticket' descripcion={trato?.tickets?.length} />
                {trato?.fechaInstalacionReal_t &&(
                    <TextInfoTicket titulo='Fecha Instalacion' descripcion={FechaFunction.format( trato?.fechaInstalacionReal_t, 'dd/MM/yyyy')} />
                )}
                <TextInfoTicket titulo='Dirección' descripcion={trato?.direccion_t} />
                {trato?.prefactibilidadRF_t && (
                    <TextInfoTicket titulo='Prefactibilidad RF' descripcion={trato?.prefactibilidadRF_t} />
                )}
                {trato?.prefactibilidadFO_t && (
                    <TextInfoTicket titulo='Prefactibilidad FO' descripcion={trato?.prefactibilidadFO_t} />
                )}
                <TextInfoTicket titulo='Creado por' descripcion={trato?.nombre_p} />
                {trato && trato?.createdAt &&(
                    <TextInfoTicket titulo='Creado el' descripcion={FechaFunction.format(new Date(trato?.createdAt), 'dd/MM/yyyy HH:mm:ss')} />
                )}
                {(trato?.nivelAutorizacion_t === 'bonificacion_nivel2' || trato?.nivelAutorizacion_t === 'bonificacion_nivel3') && !trato?.autorizadoxPersonalId_t && trato?.estadoServicio_t !== 'NO AUTORIZADO - VIP' &&(
                    <Typography sx={{color: isDarkMode ? '#ff6b6b' : '#e01010',fontWeight: 'bold',textAlign: 'center',mb: 2}} variant='h5'>Pendiente de aprobación</Typography>
                )}
                {trato?.autorizadoxPersonalId_t?.nombre_p && trato?.estadoServicio_t !== 'NO AUTORIZADO - VIP' &&(
                    <>
                        <Divider sx={{background: isDarkMode ? '#3d4a62' : '#8993a4',marginBottom:2,width: '100%'}} />
                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',textAlign: 'left',mb: 1}} variant='h6'>Autorización</Typography>
                        <TextInfoTicket titulo='Autorizado Por:' descripcion={trato?.autorizadoxPersonalId_t?.nombre_p} />
                        <TextInfoTicket titulo='Fecha Autorizado:' descripcion={FechaFunction.format( new Date(trato?.fechaAutorizado_t), 'dd/MM/yyyy HH:mm:ss')} />
                    </>
                )}
                {trato?.autorizadoxPersonalId_t?.nombre_p && trato?.estadoServicio_t === 'NO AUTORIZADO - VIP' &&(
                    <>
                        <Divider sx={{background: isDarkMode ? '#3d4a62' : '#8993a4',marginBottom:2,width: '100%'}} />
                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold',textAlign: 'left',mb: 1}} variant='h6'>No Autorizado</Typography>
                        <TextInfoTicket titulo='No Autorizado Por:' descripcion={trato?.autorizadoxPersonalId_t?.nombre_p} />
                        <TextInfoTicket titulo='Fecha No Autorizado:' descripcion={FechaFunction.format( new Date(trato?.fechaAutorizado_t), 'dd/MM/yyyy HH:mm:ss')} />
                    </>
                )}
            </Card>
            </Grid>
            <Grid item xs={12} md={9}>
                <Card sx={{background: isDarkMode ? '#2d3a52' : '#fff', border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`, p:2,borderRadius:4}}>
                    <Box sx={{ borderBottom: 1, borderColor: isDarkMode ? '#3d4a62' : '#6b788e' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                            variant="scrollable"
                            sx={{
                                '& .MuiTabs-indicator':{
                                    background: isDarkMode ? '#90caf9' : '#0364ff'
                                },
                                '& .MuiButtonBase-root':{
                                color: isDarkMode ? '#b0bec5' : '#6b788e',
                                fontWeight: 'bold'
                                },
                                '& .MuiButtonBase-root.Mui-selected':{
                                    color: isDarkMode ? '#90caf9' : '#0364ff'
                                }
                            }}
                        >
                            <Tab label="Tickets" value={0} {...a11yProps(0)} sx={{ minWidth: "150px" }}/>
                            <Tab label="Items" value={1} {...a11yProps(1)} sx={{ minWidth: "150px" }}/>
                            <Tab label="Tareas" value={2} {...a11yProps(2)} sx={{ minWidth: "150px" }}/>
                            <Tab label="Historico" value={3} {...a11yProps(3)} sx={{ minWidth: "150px" }}/>
                            {!permisos["permiso.enlaces.web"] && (
                              <>
                                <Tab label="Recordatorios" value={4} {...a11yProps(4)} sx={{ minWidth: "150px" }}/>
                                <Tab label="Ordenes de Trabajo" value={5} {...a11yProps(5)} sx={{ minWidth: "150px" }}/>
                              </>
                            )}
                            <Tab label="Equipamiento" value={6} {...a11yProps(6)} sx={{ minWidth: "150px" }}/>
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <TabCuentaTicket
                            tickets={trato?.tickets}
                            onGuardar={onGuardar}
                            servicioNewTk={{
                                nombreCompleto: trato?.nombre_t,
                                cuentaId: trato?.cuentaId_t,
                                contactoId: trato?.contactoId_t,
                                preServicioId: id
                            }}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <TabContactoPreServicio trato={trato} onGuardar={actualizarDataLogs} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <TabCuentaTareas tareas={tareas} traerTareas={actualizarTareas} />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <TabCuentaHistorico
                            historico={logs}
                            infoCliente={{
                                contactoId: trato?.contactoId_t,
                                cuentaId: trato?.cuentaId_t,
                                hiddenSelect: true,
                                preServicioId: id
                            }}
                            onGuardar={actualizarHistorico}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <TabCuentaRecodatorios
                            recordatoriosAll={recordatorios}
                            contactoId={trato?.contactoId_t}
                            cuenta={trato?.cuentaId_t}
                            nombreCompleto={trato?.nombre_t}
                            preServicioId={id}
                            onGuardar={actualizarRecordatorios}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                        <CardOTZTask otsServicio={otsServicio} />
                    </TabPanel>
                </Card>
            </Grid>
        </Grid>
        </Box>
    )
}

export default PreServicioVerScreen
